export const gutter = 60;
export const maxDimensions = `calc(100% - ${gutter * 2}px)`;
export const modalPadding = 24;
